module.exports = __webpack_public_path__ + "img/douyin_qr.dae51f34.jpg";